const conf={
  apiUrl:'https://cdaeac-back.lefil.org',
  authToken: '0qacZpS5uX_ai-ZN1Ez7aCW9vlWbkX9l',
}
export default conf;
